module.exports = __webpack_public_path__ + "/login_ui/img/lu-8c67c6a8c1cff72f7c513fe50bce6749.svg";